import './App.css';
import Footer from './component/Footer/Footer';
import Header from './component/Header/Header';
import Team from './component/Team/Team';

function App() {
  return (
    <div className="app">
        <Header></Header>
        <Team></Team>
        <Footer></Footer>
    </div>
  );
}

export default App;
